import React from 'react';
import PaimentCardForm from './PaimentCardForm';
//import bank from '../../image/Ellipse 19.png';
import batim from '../../image/Ellipse 18.png';
//import wave from '../../image/Ellipse 17.png';
//import orangeMoney from '../../image/Ellipse 16.png';
import styled from 'styled-components';

// Le conteneur qui garde les cartes en ligne sans scroll
const Container = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
`;

// Chaque carte occupe environ 23% de la largeur
const CardWrapper = styled.div`
  flex: 1 1 23%;
  min-width: 0;
`;


export default function PaimentDetail({
  comptePaiement,
  onCardClick,
}) {
  return (
    <Container>
      {comptePaiement.map((compte) => (
        <CardWrapper key={compte.id}>
          {compte.operateur_details
            ?<PaimentCardForm
              somme={compte.montant_restant}
              explain={compte.compte}
              icon={<img src={compte.operateur_details.logo} style={{width: "45px", height: "45px"}}/>}
              color={compte.operateur_details.couleur}
              onClick={() => onCardClick(compte.compte.toLowerCase())}
            />:
            <PaimentCardForm
              somme={compte.montant_restant}
              explain={compte.compte}
              icon={<img src={batim} />}
              color={`#009688`}
              onClick={() => onCardClick(compte.compte.toLowerCase())}
            />}
          </CardWrapper>
      ))}
      {/*<CardWrapper>
        <PaimentCardForm
          somme={totalCaisse}
          explain={'Caisse'}
          icon={<img src={bank} />}
          color={`#009688`}
          onClick={() => onCardClick('caisse')}
        />
      </CardWrapper>
      <CardWrapper>
        <PaimentCardForm
          somme={totalBanque}
          explain={'Banque'}
          icon={<img src={batim} />}
          color={'#283767'}
          onClick={() => onCardClick('banque')}
        />
      </CardWrapper>
      <CardWrapper>
        <PaimentCardForm
          somme={totalWave}
          explain={'Wave'}
          icon={<img src={wave} className="bg-white p-1 rounded-circle" />}
          color={'#1DC8FF'}
          onClick={() => onCardClick('wave')}
        />
      </CardWrapper>
      <CardWrapper>
        <PaimentCardForm
          somme={totalOrangeMoney}
          explain={
            <>
              <span className="d-none d-md-inline">Orange Money</span>
              <span className="d-inline d-md-none">OM</span>
            </>
          }
          icon={<img src={orangeMoney} className="bg-white p-1 rounded-circle" />}
          color={'#FF9F43'}
          onClick={() => onCardClick('orange_money')}
        />
      </CardWrapper>*/}
    </Container>
  );

}
